import React from 'react'

export default class Divider extends React.Component{

    constructor(props){
        super(props);

        this.state={};
    }

    render() {
        return(
            <div onClick={(e)=>{

                if (e.target.name === 'delete') return;

                this.props.setStyleSettings([
                    {
                        type: 'number',
                        label: 'Padding',
                        id: 'padding',
                        value: 0
                    }, {
                        type: 'showDivider',
                        label: 'Show line',
                        id: 'showDivider',
                        value: 1
                    }

                ], this.props.index, this.props.column);

                this.props.setTab('2');
            }}
            >

                <div style={{display:'flex',paddingTop:10, paddingBottom:10}}>
                    <div style={{height:1, width:'100%', backgroundColor: 'gray', opacity: this.props.elements[this.props.index].settings['showDivider']?this.props.elements[this.props.index].settings['showDivider']:1}}>

                    </div>
                </div>


            </div>
        )
    }

}

